import { firestore, } from "../firebase";

import {
  currentSeason,
} from "../data/season-constants";

import { TiebreakerCondition } from "../data/game-constants";

import { get } from "lodash";

const gameService = {};

gameService.updateGame = async (game, openSnackbar) => {
  return new Promise(async (resolve, reject) => {
    const seasonRef = firestore.collection("seasons").doc(currentSeason);
    const seasonDoc = await seasonRef.get();
    const seasonData = seasonDoc.data();

    const firstFourGameIds = [63, 64, 65, 66];
    const roundsInOrder = ["firstFour", 64, 32, 16, 8, 4, 2];
    const userScores = [];

    const {
      games,
      rounds,
      teams,
      standings,
      currentRound,
      upsets = [],
    } = seasonData;

    const {
      id: gameId,
      team1Id,
      team1Score,
      team2Id,
      team2Score,
      nextGameId,
      isTeam1Next,
      round,
    } = game;

    const currentSeasonRoundIndex = roundsInOrder.indexOf(currentRound);
    const thisRoundIndex = roundsInOrder.indexOf(round);
    const shouldUpdateRound = currentSeasonRoundIndex < thisRoundIndex;

    const isFirstFourGame = firstFourGameIds.includes(gameId);
    const roundsToUse = roundsInOrder.slice(0, roundsInOrder.indexOf(round) + 1)

    const team1 = teams[team1Id];
    const team2 = teams[team2Id];

    const {
      seed: seed1,
    } = team1;

    const {
      seed: seed2,
    } = team2;

    const winnerId = team1Score > team2Score ? team1Id : team2Id;

    let isUpset = false;
    if (winnerId === team1Id && (seed1 - seed2 >= 3)) {
      isUpset = true;
    } else if (winnerId === team2Id && (seed2 - seed1 >= 3)) {
      isUpset = true;
    }

    let updatedTeams = {
      ...teams,
    };

    if (winnerId === team1Id) {
      const updatedTeam2 = {
        ...team2,
        isEliminated: true,
      };
      updatedTeams[team2Id] = updatedTeam2;
    } else {
      const updatedTeam1 = {
        ...team1,
        isEliminated: true,
      };
      updatedTeams[team1Id] = updatedTeam1;
    }

    const updatedUpsetList = upsets.filter(id => id !== gameId);
    if (isUpset) {
      updatedUpsetList.push(gameId);
    }

    const updatedGame = {
      ...game,
      winnerId: winnerId,
      isUpset: isUpset,
      isComplete: true,
    };

    let updatedGames = {
      ...games,
      [gameId]: updatedGame,
    };

    if (!isFirstFourGame && nextGameId) {
      let updatedNextGame = {
        ...games[nextGameId],
      };

      if (isTeam1Next) {
        updatedNextGame.team1Id = winnerId;
      } else {
        updatedNextGame.team2Id = winnerId;
      }

      updatedGames = {
        ...updatedGames,
        [nextGameId]: updatedNextGame,
      };
    }

    const roundData = rounds[round];

    const {
      pointsPerGame,
    } = roundData;

    const batch = firestore.batch();

    seasonRef.collection("user_entries").get().then((snapshot) => {
      snapshot.forEach((doc) => {
        const userEntrySnapshot = doc.data();
  
        const {
          picksByGame,
          scoring,
          upsetsCorrect = 0,
          totalUpsetPoints = 0,
          upsets: userUpsets = [],
          firstFourPicks,
          championshipTiebreakerPoints = 0,
        } = userEntrySnapshot;
  
        if (picksByGame || (isFirstFourGame && get(firstFourPicks, gameId))) {

          let winner = "";
          if (isFirstFourGame) {
            winner = get(firstFourPicks, gameId)
          } else {
            const pickForGame = picksByGame[gameId];

            const {
              winner: winnerPick,
            } = pickForGame;
            winner = winnerPick;
          }

          let pointsScored = 0;
          let updatedUpsetsCorrect = upsetsCorrect;
          let updatedTotalUpsetPoints = totalUpsetPoints;
          const userUpdatedUpsetList = userUpsets.filter(id => id !== gameId);

          if (winnerId === winner) {
            pointsScored = isUpset ? pointsPerGame * 2 : pointsPerGame;

            if (isUpset) {
              updatedUpsetsCorrect += 1;
              updatedTotalUpsetPoints += pointsPerGame;
              userUpdatedUpsetList.push(gameId);
            }
          }

          const previousOverallPoints =
            (get(scoring, ["overall"]) ?? 0);

          const previousRoundPoints =
            (get(scoring, ["byRound", round, "points"]) ?? 0);
    
          const previousGamePoints =
            (get(scoring, ["byGame", gameId]) ?? 0)

          const scoringByRound = get(scoring, "byRound") ?? {};
          const scoringByGame = get(scoring, "byGame") ?? {};

          const updatedOverallPoints = previousOverallPoints -
            previousGamePoints + pointsScored;
    
          const updatedRoundPoints = previousRoundPoints -
            previousGamePoints + pointsScored;

          const updatedScoring = {
            ...scoring,
            overall: updatedOverallPoints,
            byRound: {
              ...scoringByRound,
              [round]: {
                points: updatedRoundPoints,
              },
            },
            byGame: {
              ...scoringByGame,
              [gameId]: pointsScored,
            },
          };

          const score = roundsToUse.map((round) => get(updatedScoring, ["byRound", round, "points"]) ?? 0)
            .reduce((a, b) => a + b);
          userScores.push({
            id: doc.id,
            score: score,
            scoring: updatedScoring,
            championshipTiebreakerPoints: championshipTiebreakerPoints,
          });

          batch.set(doc.ref, 
            { 
              scoring: updatedScoring,
              upsets: userUpdatedUpsetList,
            },
            { merge: true }
          );
        }
      });
    }).catch((reason) => {
      reject(reason);
    }).then(async () => {
      const sortedUserScores = sortUserScores(userScores);
      console.log(sortedUserScores);

      let currentRank = 1;
      const allEntriesBreakTies = [];
      sortedUserScores.forEach((entry, index) => {
        if (index !== 0) {
          if (entry.score !==
              sortedUserScores[index - 1].score) {
            currentRank = index + 1;
          }
        }
        allEntriesBreakTies.push({
          ...entry,
          rank: currentRank,
        });
      });

      if (round === 2) {
        applyChampionshipTiebreakers(allEntriesBreakTies, game);
        allEntriesBreakTies.forEach((entry) => {
          delete entry.scoring;
          delete entry.championshipTiebreakerPoints;
        });
      }

      const updatedRoundStandings = {
        ...standings,
        byRound: {
          ...standings.byRound,
          [round]: allEntriesBreakTies,
        },
      };

      batch.set(seasonRef, 
        { 
          games: updatedGames,
          teams: updatedTeams,
          upsets: updatedUpsetList,
          standings: updatedRoundStandings,
          ...(shouldUpdateRound && {currentRound: round})
        },
        { merge: true }
      );
      console.log(updatedRoundStandings);

      await batch.commit()
        .then(() => {
          openSnackbar("Saved game!", "success")
        })
        .catch((reason) => {
          reject(reason);
        });
    })
  });
};

const sortUserScores = (userScores) => {
  return userScores.sort(function(a, b) {
    return b.score - a.score;
  });
};

const getTotalGamesCorrect = (entry, game) => {
  const byGame = get(entry, "scoring.byGame") ?? {};
  let count = 0;
  for (let id = 0; id <= game.id; id++) {
    if (byGame[id] > 0) count++;
  }
  return count;
};

/**
 * Applies tiebreaker conditions for the championship game.
 * Mutates entries in-place, updating rank for ties at 1st, 2nd, or 3rd place.
 * @param {Array} entries - Sorted entries with { id, score, rank, scoring }
 * @param {Object} game - The championship game object (includes actual scores)
 */
const applyChampionshipTiebreakers = (entries, game) => {
  const tiedPlaces = [1, 2, 3];

  tiedPlaces.forEach((place) => {
    const tiedEntries = entries.filter((e) => e.rank === place);
    if (tiedEntries.length <= 1) return;

    const actualChampionshipScore = game.team1Score + game.team2Score;

    tiedEntries.forEach((entry) => {
      entry._gamesCorrect = getTotalGamesCorrect(entry, game);
      entry._scoreDiff = Math.abs((entry.championshipTiebreakerPoints ?? 0) - actualChampionshipScore);
    });

    tiedEntries.sort((a, b) => {
      const gamesCorrectDiff = b._gamesCorrect - a._gamesCorrect;
      if (gamesCorrectDiff !== 0) return gamesCorrectDiff;
      return a._scoreDiff - b._scoreDiff;
    });

    const leader = tiedEntries[0];
    tiedEntries.forEach((entry, i) => {
      entry.rank = place + i;

      if (i > 0) {
        entry.tiebreakerCondition = entry._gamesCorrect !== leader._gamesCorrect
          ? TiebreakerCondition.TOTAL_GAMES
          : TiebreakerCondition.CHAMPIONSHIP_POINTS;
      }
    });

    tiedEntries.forEach((entry) => {
      delete entry._gamesCorrect;
      delete entry._scoreDiff;
    });
  });
};

export default gameService;